<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>{{$t('pageLeads.list.title')}}: {{ chat_id }}</h1>
      </v-flex>
      <v-flex xs12 py-0 pb-5>
        <v-divider />
      </v-flex>
    </v-layout>
    <span @click="$router.push({ name: 'LeadUserList' })" class="goback"
      >{{$t('pageLeads.list.goBack')}}</span
    >

    <v-layout row wrap block v-if="errors">
      <v-flex xs12>
        <h2>{{ errors }}</h2>
      </v-flex>
    </v-layout>

    <!-- chat -->
    <v-layout>
      <v-flex xs12 pt-0>
        <div class="block">
          <chat-lead :chat-id="chat_id"></chat-lead>
        </div>
      </v-flex>
    </v-layout>

    <v-layout
      row
      wrap
      verificator__bid
      v-if="isLoaded && items && items.length"
    >
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="id"
          class="main-table-verificator-list"
        >
          <template v-slot:item="{ item }">
            <tr @click="openLead(item)">
              <td class="nowrap">
                {{ item.fio }}
              </td>
              <td class="text-center">
                {{ item.phone | formatPhone }}
              </td>
              <td class="text-center">
                {{ item.timezone }}
              </td>
              <td class="text-left">
                {{ item.region }}
              </td>
              <td class="text-center">
                {{ item.created_at | formatDate }}
              </td>
              <td class="text-center">
                {{ item.wait_type }}
              </td>
              <td class="text-center">
                <v-chip
                  label
                  :text-color="getStatus(item.status, 'text')"
                  :color="getStatus(item.status, 'color')"
                >
                  {{ getStatus(item.status, "name") }}
                </v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-layout row warp v-if="isLoaded && items && !items.length">
      <v-flex xs12>
        <h2 class="empty_title">{{$t('pageLeads.list.emptyTitle')}}</h2>
      </v-flex>
      <v-flex xs12>
        <v-divider />
      </v-flex>
      <v-flex xs12 mt-5>
        <v-layout row wrap>
          <v-flex xs12 text-center>
            <h2>{{$t('pageLeads.list.searchFromNumber')}}</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex shrink pr-0>
            <v-text-field
              v-model="bidId"
              :label="$t('pageLeads.list.numberBid')"
              class="mt-0 pt-0"
            ></v-text-field>
          </v-flex>
          <v-flex shrink pl-0>
            <v-btn @click="findBidById" color="primary" icon>
              <v-icon color="primary">search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="isBidExist">
          <v-flex xs12>
            <h3>{{$t('pageLeads.list.noFounded')}}</h3>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <loading :text="$t('pageLeads.list.loading')" v-if="!isLoaded" />
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import { mapState } from "vuex";
import statusNames from "@/utils/data/statuses";
import showNotify from "@/services/noty";
import formatDate from "@/mixins/filters/formatDate";
import formatDateFrom from "@/mixins/filters/formatDateFrom";
import formatPhone from "@/mixins/filters/formatPhone";
import ChatLead from "@/components/lead/chat";
//import moment from "moment";
import i18n from "@/services/i18n";

export default {
  name: "LeadList",
  components: { ChatLead },
  mixins: [formatDate, formatDateFrom, formatPhone],
  data: () => ({
    chat_id: "",
    items: null,
    errors: null,
    isLoaded: false,
    statusNames,

    headers: [
      {
        text: i18n.t('pageLeads.list.table.fields.fio'),
        value: "fio",
        align: "left",
        sortable: true,
      },
      {
        text: i18n.t('pageLeads.list.table.fields.phone'),
        value: "phone",
        align: "center",
        sortable: true,
      },
      {
        text: i18n.t('pageLeads.list.table.fields.timezone'),
        value: "timezone",
        align: "center",
        sortable: true,
      },
      {
        text: i18n.t('pageLeads.list.table.fields.region'),
        value: "region",
        align: "left",
        sortable: true,
      },
      {
        text: i18n.t('pageLeads.list.table.fields.created_at'),
        value: "created_at",
        align: "center",
        sortable: true,
      },
      {
        text: i18n.t('pageLeads.list.table.fields.wait_type'),
        value: "wait_type",
        align: "center",
        sortable: true,
      },
      {
        text: i18n.t('pageLeads.list.table.fields.status'),
        value: "status",
        align: "center",
        sortable: true,
      },
    ],
  }),
  computed: {
    ...mapState({
      wSocket: (state) => state.wSocket.message,
    }),
  },
  watch: {
    wSocket(message) {
      this.getSocketMessage(message);
    },
  },
  created() {
    this.chat_id = (new String(this.$route.params.chat_id)).toString();
    this.getLeads();
  },
  methods: {
    openLead(item) {
      this.$router.push({
        name: "LeadEdit",
        params: { chat_id: this.chat_id, id: item.id },
      });
    },
    getStatus(id, param) {
      return this.statusNames["leads"][id][param]
        ? this.statusNames["leads"][id][param]
        : "";
    },
    async getLeads() {
      this.errors = null;
      this.isLoaded = false;

      await apiCallTrue({
        url: `v1/leads/${this.chat_id}`,
      })
        .then((response) => {
          if (response.data.data) {
            this.items = response.data.data;
          } else {
            this.items = [];
          }
        })
        .catch((error) => {
          this.errors = error.message;
          showNotify("error", error);
        })
        .finally(() => {
          this.isLoaded = true;
        });
    },

    getSocketMessage(message) {
      switch (message.type) {
        case 2:
          if (message && message.action === "updateLead" && parseInt(message.data) === parseInt(this.chat_id)) {
            console.log("WSLIST updateLead", message);
            this.getLeads();
          }
          break;
      }
    },
  },
};
</script>

<style lang="scss">
</style>
